import { render, staticRenderFns } from "./TechniquePage.vue?vue&type=template&id=5fab37fb&"
import script from "./TechniquePage.vue?vue&type=script&lang=js&"
export * from "./TechniquePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports